var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#3B82F6",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.7725V5.22705L15 9.99978L7.5 14.7725Z",
    fill: "#3B82F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressCircle);
export default __webpack_public_path__ + "static/media/inProgressCircle.41a606a57bf9f8939252d3e3a09a9f38.svg";
export { ForwardRef as ReactComponent };